<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading" :btnConfigurazioniVisible="btnConfigurazioniVisible" :linkConfigurazioni="linkConfigurazioni">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Nome</label>
                        <b-form-input v-model="filtroConfigurazioneAree.nome" type="search" id="codice" placeholder="Inserire Nome..."></b-form-input>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-configurazione-aree-list-component ref="RsaConfigurazioneAreeListComponent" @afterLoadData="onAfterLoadData"></rsa-configurazione-aree-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneAreeListComponent from "../components/RsaConfigurazioneAreeListComponent.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneAreeListComponent },
    data() {
        return {
            filtroConfigurazioneAree: { nome: null },
            btnNewVisible: true,
            btnBackVisible: true,
            btnConfigurazioniVisible: true,
            pathResource: "/rsaaree",
            linkedit: "/rsaconfigurazionearee",
            linkConfigurazioni: "/configurazioni",
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroConfigurazioneAree"]) {
            me.filtroConfigurazioneAree = JSON.parse(sessionStorage["filtroConfigurazioneAree"]);
        }
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.RsaConfigurazioneAreeListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onReset() {
            let me = this;
            me.filtroConfigurazioneAree = { nome: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneAree"] = JSON.stringify(me.filtroConfigurazioneAree);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneAree"] = JSON.stringify(me.filtroConfigurazioneAree);
            me.loadData();
        },
    },
};
</script>

<style></style>
